import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import config from "../Config"
// import { htbImages } from "../dummyData"
import i18n from "../i18n"

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`

const Header = styled.span`
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 20px;
`

const Row = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
`

const HowBid = ({ title, theme }) => {
  // const [htbImages, setHtbImages] = React.useState([])

  // React.useEffect(
  //   () => {
  //     const arr = Object.values(theme.howToBidImages)
  //     setHtbImages(arr)
  //   },
  //   [theme, htbImages]
  // )

  const htbImages = Object.values(theme.howToBidImages)

  console.log("theme", theme)
  console.log("theme.howToBidImages", theme.howToBidImages)
  console.log("htbImages", htbImages)
  return (
    <Container>
      {title && <Header className='montserratRegular'>{title}</Header>}
      {/* {
			[275,362,186,249,249].map((height,index)=> {
				return <Row key={height}>
				<img width="289px" height={`${height}px`} src={`${config.BIDNWIN_S3_IMAGE_URL}/`+i18n.t('step')+`-${++index}.`+ i18n.t('step_file_type')} alt="how-bid-work"/>
				</Row>
			})
		} */}
      {htbImages.map((img, index) => {
        return (
          <Row key={index}>
            <img
              style={{
                width: "100%",
                maxWidth: "291px",
              }}
              src={img}
              alt={`Step ${index} of How to Bid`}
            />
          </Row>
        )
      })}
    </Container>
  )
}

HowBid.propTypes = {
  title: PropTypes.string,
}

export default HowBid



// WEBPACK FOOTER //
// ./src/views/HowBid.js